import styled from "@emotion/styled"
import Link from "next/link"
import { useInView } from "react-intersection-observer"
import colors from "theme/colors"
import { Container, NewText, transitionDelayTime, TransitionUp, useInViewConfig } from "ui"
import ImageWithAlt from "ui/ImageWithAlt"
import { extractImage, extractProperty } from "utils"

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  margin-bottom: 56px;

  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 20.5px;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 112px;
  }
`

const StyledContactContainer = styled.div`
  border-radius: 12px;
  border: 2px solid ${colors.darkGreen};
  background: ${colors.white};
  padding: 24px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`

const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 16px;
    margin-top: 24px;
  }
`
type Props = {
  data: any
}

function BonitaContactInfo({ data }: Props) {
  const infoBlock = extractProperty(data, "infoBlock")
  const { ref: mobileRef, inView: mobileInView } = useInView(useInViewConfig)

  return (
    <Container>
      <StyledContainer ref={mobileRef}>
        {infoBlock?.map((info: any, index: number) => {
          const image = extractImage(info, "icon")
          const title = extractProperty(info, "title")
          const shortDescription = extractProperty(info, "shortDescription")
          const wayToContact = extractProperty(info, "wayToContact")
          return (
            <TransitionUp
              key={index.toString()}
              $inView={mobileInView}
              $delay={transitionDelayTime * 0.5 * index}
            >
              <StyledContactContainer key={index.toString()}>
                <ImageWithAlt image={image} width={32} height={32} />
                <StyledTextContainer>
                  <NewText
                    component={"h2"}
                    desktopFontSize={32}
                    desktopLineHeight={"36px"}
                    desktopFontWeight={400}
                    mobileFontSize={24}
                    mobileLineHeight={"35px"}
                    color={colors.black}
                  >
                    {title}
                  </NewText>
                  <NewText
                    component={"p"}
                    desktopFontSize={16}
                    desktopLineHeight={"23px"}
                    desktopFontWeight={400}
                    color={colors.black}
                  >
                    {shortDescription}
                  </NewText>
                  <Link style={{ textDecoration: "none" }} href={wayToContact?.[0]?.url}>
                    <NewText
                      component={"p"}
                      desktopFontSize={14}
                      desktopLineHeight={"20px"}
                      desktopFontWeight={600}
                      color={colors.darkGreen}
                    >
                      {wayToContact?.[0]?.name}
                    </NewText>
                  </Link>
                </StyledTextContainer>
              </StyledContactContainer>
            </TransitionUp>
          )
        })}
      </StyledContainer>
    </Container>
  )
}

export default BonitaContactInfo
